export const loginState = {
  //'Du er en hjelpsom assistent som svarer kort og konsist på norsk.',
  msalInstance: null,
  isAuthenticated: false,
  isInitialized: false,
  idToken: '',
  accessToken: '',
  isLoggedIn: '',
  expires: '',
  userName: '',
  userEmail: '',
  microsoftLogin: null,
  googleLogin: null,
  feideLogin: null,
  loginType: '',
  educatorInfo: {}
}
